'use client'

import { TabsContentWrapper, TabsList, TabsProvider, TabsRoot, TabsTrigger, TabsTriggerContent } from './tabs-base'
import type { TabsProps } from './tabs.types'

export const Tabs = ({
  defaultValue,
  tabs,
  variant,
  className,
  tabsListClassName,
  tabClassName,
  tabContentClassName,
  tabsContentClassName,
  orientation,
  children,
  endTabsListSlot,
  onValueChange,
  inverseBorder,
}: TabsProps) => {
  return (
    <TabsProvider
      tabs={tabs}
      variant={variant}
      orientation={orientation}
      defaultValue={defaultValue ?? tabs.find((tab) => tab.isActive)?.id ?? tabs[0].id}
      onValueChange={onValueChange}
    >
      <TabsRoot className={className}>
        <TabsList className={tabsListClassName}>
          {tabs.map((tab, index) => {
            return (
              <TabsTrigger
                key={`tab-header-${tab.id}`}
                value={tab.id}
                inverseBorder={inverseBorder}
                className={tabClassName}
                asChild
              >
                <TabsTriggerContent
                  tab={tab}
                  index={index}
                  isLast={index === tabs.length - 1}
                  className={tabContentClassName}
                />
              </TabsTrigger>
            )
          })}
          {endTabsListSlot && <div className='flex flex-1 justify-end'>{endTabsListSlot}</div>}
        </TabsList>

        <TabsContentWrapper className={tabsContentClassName}>{children}</TabsContentWrapper>
      </TabsRoot>
    </TabsProvider>
  )
}
